 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-About-vue":"view-About-vue","view-Events__REMOVE-vue":"view-Events__REMOVE-vue","view-Media-vue":"view-Media-vue","view-Ministries-vue":"view-Ministries-vue","view-Offerings-vue":"view-Offerings-vue","view-Visit-vue":"view-Visit-vue","view-WelcomAnim-vue":"view-WelcomAnim-vue","view-Welcome-vue":"view-Welcome-vue","view-about-cor_bishop-vue":"view-about-cor_bishop-vue","view-about-cor_partners-vue":"view-about-cor_partners-vue","view-about-cor_staff-vue":"view-about-cor_staff-vue","view-about-cor_ucc-vue":"view-about-cor_ucc-vue","view-contact-contactForm-vue~view-ministries-prayer-circle-vue~view-visit-contact-vue~view-visit-req~c051e99c":"view-contact-contactForm-vue~view-ministries-prayer-circle-vue~view-visit-contact-vue~view-visit-req~c051e99c","view-contact-contactForm-vue":"view-contact-contactForm-vue","view-media-live-service-vue~view-visit-site-rental-vue~view-welcome-events-vue~view-welcome-news-vue":"view-media-live-service-vue~view-visit-site-rental-vue~view-welcome-events-vue~view-welcome-news-vue","view-ministries-prayer-circle-vue~view-visit-request-form-vue~view-visit-site-rental-vue":"view-ministries-prayer-circle-vue~view-visit-request-form-vue~view-visit-site-rental-vue","view-visit-request-form-vue":"view-visit-request-form-vue","view-visit-site-rental-vue":"view-visit-site-rental-vue","view-ministries-prayer-circle-vue":"view-ministries-prayer-circle-vue","view-visit-contact-vue":"view-visit-contact-vue","view-contact-email-vue":"view-contact-email-vue","view-contact-link-vue":"view-contact-link-vue","view-contact-newsletterForm-vue":"view-contact-newsletterForm-vue","view-contact-prayerForm-vue":"view-contact-prayerForm-vue","view-d-parallax-vue":"view-d-parallax-vue","view-events_REMOVE-our-calendar-vue":"view-events_REMOVE-our-calendar-vue","view-media-bible-study__Remove-vue":"view-media-bible-study__Remove-vue","view-media-cor-interviews-vue":"view-media-cor-interviews-vue","view-media-facebook-vue":"view-media-facebook-vue","view-media-live-service-vue":"view-media-live-service-vue","view-welcome-events-vue":"view-welcome-events-vue","view-welcome-news-vue":"view-welcome-news-vue","view-media-social-vue":"view-media-social-vue","view-media-twitter-vue":"view-media-twitter-vue","view-ministries-art_music-vue":"view-ministries-art_music-vue","view-ministries-education-vue":"view-ministries-education-vue","view-ministries-food-pantry-vue":"view-ministries-food-pantry-vue","view-ministries-member-services-vue":"view-ministries-member-services-vue","view-ministries-mens-vue":"view-ministries-mens-vue","view-ministries-youth-vue":"view-ministries-youth-vue","view-offerings-amazon-smile-vue":"view-offerings-amazon-smile-vue","view-offerings-tithes-vue":"view-offerings-tithes-vue","view-visit-citizen-action-vue":"view-visit-citizen-action-vue","view-visit-our-church-vue":"view-visit-our-church-vue","view-welcome-home-vue":"view-welcome-home-vue","view-welcome-news-article-vue":"view-welcome-news-article-vue"}[chunkId]||chunkId) + "." + {"view-About-vue":"9fe7ee30","view-Events__REMOVE-vue":"b8196af1","view-Media-vue":"affe735d","view-Ministries-vue":"deacbed7","view-Offerings-vue":"cd6f2fe0","view-Visit-vue":"18bd3ae9","view-WelcomAnim-vue":"19772c17","view-Welcome-vue":"5170fd16","view-about-cor_bishop-vue":"27f9eba0","view-about-cor_partners-vue":"76d7ebfe","view-about-cor_staff-vue":"8cc7c873","view-about-cor_ucc-vue":"b3deecc7","view-contact-contactForm-vue~view-ministries-prayer-circle-vue~view-visit-contact-vue~view-visit-req~c051e99c":"9e690278","view-contact-contactForm-vue":"758e2af8","view-media-live-service-vue~view-visit-site-rental-vue~view-welcome-events-vue~view-welcome-news-vue":"6e447021","view-ministries-prayer-circle-vue~view-visit-request-form-vue~view-visit-site-rental-vue":"abf7d350","view-visit-request-form-vue":"b3ba5b8f","view-visit-site-rental-vue":"68ec25fb","view-ministries-prayer-circle-vue":"1b3d5fa9","view-visit-contact-vue":"941d144b","view-contact-email-vue":"de32217a","view-contact-link-vue":"89a22322","view-contact-newsletterForm-vue":"6685a512","view-contact-prayerForm-vue":"babdfdda","view-d-parallax-vue":"9dd1491c","view-events_REMOVE-our-calendar-vue":"1ea9560f","view-media-bible-study__Remove-vue":"f7920eac","view-media-cor-interviews-vue":"ab816b01","view-media-facebook-vue":"41928086","view-media-live-service-vue":"13da5b96","view-welcome-events-vue":"a6ec00e7","view-welcome-news-vue":"b6596e1b","view-media-social-vue":"63afff07","view-media-twitter-vue":"c304a9d1","view-ministries-art_music-vue":"4c338c61","view-ministries-education-vue":"c7f0dbe4","view-ministries-food-pantry-vue":"a7a13e0b","view-ministries-member-services-vue":"342d07ac","view-ministries-mens-vue":"42147865","view-ministries-youth-vue":"2f3d84b0","view-offerings-amazon-smile-vue":"3ab7753b","view-offerings-tithes-vue":"14bf6108","view-visit-citizen-action-vue":"f812cfb7","view-visit-our-church-vue":"bf5ea26b","view-welcome-home-vue":"7107232b","view-welcome-news-article-vue":"0694e923"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-About-vue":1,"view-Events__REMOVE-vue":1,"view-Media-vue":1,"view-Ministries-vue":1,"view-Offerings-vue":1,"view-Visit-vue":1,"view-WelcomAnim-vue":1,"view-Welcome-vue":1,"view-about-cor_bishop-vue":1,"view-about-cor_partners-vue":1,"view-about-cor_staff-vue":1,"view-about-cor_ucc-vue":1,"view-contact-contactForm-vue~view-ministries-prayer-circle-vue~view-visit-contact-vue~view-visit-req~c051e99c":1,"view-ministries-prayer-circle-vue~view-visit-request-form-vue~view-visit-site-rental-vue":1,"view-visit-request-form-vue":1,"view-visit-site-rental-vue":1,"view-ministries-prayer-circle-vue":1,"view-contact-email-vue":1,"view-contact-link-vue":1,"view-d-parallax-vue":1,"view-media-cor-interviews-vue":1,"view-media-live-service-vue":1,"view-welcome-events-vue":1,"view-welcome-news-vue":1,"view-ministries-art_music-vue":1,"view-ministries-education-vue":1,"view-ministries-food-pantry-vue":1,"view-ministries-member-services-vue":1,"view-ministries-mens-vue":1,"view-ministries-youth-vue":1,"view-visit-our-church-vue":1,"view-welcome-home-vue":1,"view-welcome-news-article-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-About-vue":"view-About-vue","view-Events__REMOVE-vue":"view-Events__REMOVE-vue","view-Media-vue":"view-Media-vue","view-Ministries-vue":"view-Ministries-vue","view-Offerings-vue":"view-Offerings-vue","view-Visit-vue":"view-Visit-vue","view-WelcomAnim-vue":"view-WelcomAnim-vue","view-Welcome-vue":"view-Welcome-vue","view-about-cor_bishop-vue":"view-about-cor_bishop-vue","view-about-cor_partners-vue":"view-about-cor_partners-vue","view-about-cor_staff-vue":"view-about-cor_staff-vue","view-about-cor_ucc-vue":"view-about-cor_ucc-vue","view-contact-contactForm-vue~view-ministries-prayer-circle-vue~view-visit-contact-vue~view-visit-req~c051e99c":"view-contact-contactForm-vue~view-ministries-prayer-circle-vue~view-visit-contact-vue~view-visit-req~c051e99c","view-contact-contactForm-vue":"view-contact-contactForm-vue","view-media-live-service-vue~view-visit-site-rental-vue~view-welcome-events-vue~view-welcome-news-vue":"view-media-live-service-vue~view-visit-site-rental-vue~view-welcome-events-vue~view-welcome-news-vue","view-ministries-prayer-circle-vue~view-visit-request-form-vue~view-visit-site-rental-vue":"view-ministries-prayer-circle-vue~view-visit-request-form-vue~view-visit-site-rental-vue","view-visit-request-form-vue":"view-visit-request-form-vue","view-visit-site-rental-vue":"view-visit-site-rental-vue","view-ministries-prayer-circle-vue":"view-ministries-prayer-circle-vue","view-visit-contact-vue":"view-visit-contact-vue","view-contact-email-vue":"view-contact-email-vue","view-contact-link-vue":"view-contact-link-vue","view-contact-newsletterForm-vue":"view-contact-newsletterForm-vue","view-contact-prayerForm-vue":"view-contact-prayerForm-vue","view-d-parallax-vue":"view-d-parallax-vue","view-events_REMOVE-our-calendar-vue":"view-events_REMOVE-our-calendar-vue","view-media-bible-study__Remove-vue":"view-media-bible-study__Remove-vue","view-media-cor-interviews-vue":"view-media-cor-interviews-vue","view-media-facebook-vue":"view-media-facebook-vue","view-media-live-service-vue":"view-media-live-service-vue","view-welcome-events-vue":"view-welcome-events-vue","view-welcome-news-vue":"view-welcome-news-vue","view-media-social-vue":"view-media-social-vue","view-media-twitter-vue":"view-media-twitter-vue","view-ministries-art_music-vue":"view-ministries-art_music-vue","view-ministries-education-vue":"view-ministries-education-vue","view-ministries-food-pantry-vue":"view-ministries-food-pantry-vue","view-ministries-member-services-vue":"view-ministries-member-services-vue","view-ministries-mens-vue":"view-ministries-mens-vue","view-ministries-youth-vue":"view-ministries-youth-vue","view-offerings-amazon-smile-vue":"view-offerings-amazon-smile-vue","view-offerings-tithes-vue":"view-offerings-tithes-vue","view-visit-citizen-action-vue":"view-visit-citizen-action-vue","view-visit-our-church-vue":"view-visit-our-church-vue","view-welcome-home-vue":"view-welcome-home-vue","view-welcome-news-article-vue":"view-welcome-news-article-vue"}[chunkId]||chunkId) + "." + {"view-About-vue":"1fcf1cea","view-Events__REMOVE-vue":"3311ebb0","view-Media-vue":"b6529100","view-Ministries-vue":"fae170d3","view-Offerings-vue":"7de2a5ac","view-Visit-vue":"a24366f2","view-WelcomAnim-vue":"4eeaaf3d","view-Welcome-vue":"0e433876","view-about-cor_bishop-vue":"0ce7f272","view-about-cor_partners-vue":"3968232c","view-about-cor_staff-vue":"5e142858","view-about-cor_ucc-vue":"c522c002","view-contact-contactForm-vue~view-ministries-prayer-circle-vue~view-visit-contact-vue~view-visit-req~c051e99c":"8180162b","view-contact-contactForm-vue":"31d6cfe0","view-media-live-service-vue~view-visit-site-rental-vue~view-welcome-events-vue~view-welcome-news-vue":"31d6cfe0","view-ministries-prayer-circle-vue~view-visit-request-form-vue~view-visit-site-rental-vue":"1c040d8f","view-visit-request-form-vue":"166cf5ff","view-visit-site-rental-vue":"42a77c9b","view-ministries-prayer-circle-vue":"fe7a7e6e","view-visit-contact-vue":"31d6cfe0","view-contact-email-vue":"5e142858","view-contact-link-vue":"0423c551","view-contact-newsletterForm-vue":"31d6cfe0","view-contact-prayerForm-vue":"31d6cfe0","view-d-parallax-vue":"d919cf28","view-events_REMOVE-our-calendar-vue":"31d6cfe0","view-media-bible-study__Remove-vue":"31d6cfe0","view-media-cor-interviews-vue":"c29cb00c","view-media-facebook-vue":"31d6cfe0","view-media-live-service-vue":"6673cdb5","view-welcome-events-vue":"2dd36f49","view-welcome-news-vue":"ac3d51b4","view-media-social-vue":"31d6cfe0","view-media-twitter-vue":"31d6cfe0","view-ministries-art_music-vue":"7278508b","view-ministries-education-vue":"befb6ae6","view-ministries-food-pantry-vue":"308bc889","view-ministries-member-services-vue":"a89f331b","view-ministries-mens-vue":"f50b7369","view-ministries-youth-vue":"6edf0ba5","view-offerings-amazon-smile-vue":"31d6cfe0","view-offerings-tithes-vue":"31d6cfe0","view-visit-citizen-action-vue":"31d6cfe0","view-visit-our-church-vue":"29be35da","view-welcome-home-vue":"b3f7d490","view-welcome-news-article-vue":"445c3afc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
